import { ProductListProductWithAccountRequestDto } from '@epicuro-next/data/engagement/engagement-models';
import { ProductReference } from '@epicuro-next/models/engagement';

import { mapSearchSortTypeByOrdinal } from '../map-sort-field/map-sort-field';

export function extractProductByReferencesPayload(
  query: ProductListProductWithAccountRequestDto,
) {
  const {
    productListId,
    siteId,
    start,
    num,
    available,
    productReferences,
    accountId,
    sortField,
  } = query;

  return {
    start,
    num,
    available,
    sortField: mapSearchSortTypeByOrdinal(sortField),
    productListId: productListId ?? '',
    productReferences: productReferences as ProductReference[],
    accountId: accountId ?? '',
    site: siteId ?? '',
  };
}
